import { inject, Injectable } from '@angular/core';
import { filter, Observable, ReplaySubject } from 'rxjs';
import { MicrosoftSecurityGroupsFieldConfig } from '../models/generated/ziroModels';
import { HttpClient } from '@angular/common/http';
import { switchMap, take, tap } from 'rxjs/operators';
import { MicrosoftTenantsStateContext } from './microsoft-tenants-state.context';

@Injectable()
export class MicrosoftSecurityGroupsMembershipContext {
  private http = inject(HttpClient);
  private _tenantsStateContext = inject(MicrosoftTenantsStateContext);

  private _stateSource = new ReplaySubject<MicrosoftSecurityGroupsFieldConfig>(1);
  state$ = this._stateSource.asObservable();
  private _tenantId: string;

  constructor() {
    this.refresh().subscribe();
  }

  refresh(): Observable<MicrosoftSecurityGroupsFieldConfig> {
    return this._tenantsStateContext.cachedTenantState$.pipe(
      filter((cachedTenant) => !!cachedTenant?.tenantId),
      take(1),
      tap((cachedTenant) => {
        this._tenantId = cachedTenant?.tenantId?.toString();
      }),
      switchMap(() =>
        this._getSecurityGroupsFieldConfig().pipe(
          tap((securityGroupSettings: MicrosoftSecurityGroupsFieldConfig) => {
            this._stateSource.next(securityGroupSettings);
          }),
        ),
      ),
    );
  }

  private _getSecurityGroupsFieldConfig(): Observable<MicrosoftSecurityGroupsFieldConfig> {
    return this.http.get<MicrosoftSecurityGroupsFieldConfig>(
      `/services/microsoft/field-configs/tenants/${this._tenantId}/security-group-permissions`,
    );
  }
}
